
import { Vue, Component, Prop } from 'vue-property-decorator';
import Loading from '@/components/loading/index.vue';
import lazyInject from '@/di';
import WorkbenchesService from '@/services/workbenches.service';
import { getCurrentMonth } from '@/common/utils';

@Component({
  components: {
    Loading,
  },
})
export default class Representative extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;
  lading = false;
  typeList: any = {
    // 大B组员
    kaTeam: ['workbenches.ShouldBeCharged', 'workbenches.StoreConsumed'],
    // 大B组长
    kaTeamLeader: ['workbenches.ShouldBeCharged', 'workbenches.StoreConsumed'],
    // 大B部长
    kaTeamMinister: [],
    // 小B组员
    ordinaryTeam: ['workbenches.ShouldBeCharged', 'workbenches.CollisionLineStore', 'workbenches.MergePaymentIng', 'workbenches.StoreConsumed'],
    // 小B组长
    ordinaryTeamLeader: ['workbenches.ShouldBeCharged', 'workbenches.CollisionLineStore', 'workbenches.MergePaymentIng', 'workbenches.StoreConsumed'],
    // 小B部长
    ordinaryTeamMinister: [],
    // 助理总监
    assistantDirector: [],
    // 总监
    director: [],

  };

  @Prop({ type: String, default: 'kaTeamMinister' })
  type?: any;

  @Prop({ type: Array, default: [] })
  userModule?: any;

  data: any = {
    need_recharge: 0, // 应充商家
    ad_campaign_overflow: 0, // 撞线门店
    need_deployed: 0, // 合并支付待投放
    ad_campaign_recharge_shop: 0, // 推广通充值门店
    activity_sign_service: 0, // 未完成活动门店数量
    activity_sign_cps: 0, // CPS标品招商未完成数量
    agent_gmv: 0, // GMV未完成金额
  };

  async init() {
    try {
      const res = await this.workbenchesService.getMyTodo();
      if (res) {
        this.data = res;
        this.lading = true;
      }
    } catch (error) {
      this.lading = true;
    }
  }
  clase() {
    this.lading = true;
  }

  handleClick(name: string, module: any) {
    if (name === 'workbenches.MergePaymentIng') {
      const query: any = {
        month: getCurrentMonth(),
        module,
      };
      this.$router.push({
        name,
        query,
      });
    } else {
      this.$router.push({ name, query: { module } });
    }
  }
  getToShop() {
    const query: any = {
      platformSpuBindStatus: 3,
      campaignAgent: '',
    };
    this.$router.push({
      name: 'main.shop.list',
      query,
    });
  }
}
